import { roundTo } from "../../utils/numbers";

/**
 * Convert guidance scale to a prompt strength value between 0 and 100. High prompt strength means
 * the image generation will more closely follow the prompt. Low prompt strength means the image will
 * be more creative.
 *
 * - Guidance scale of 2 is prompt strength 100
 * - Guidance scale of 4 is prompt strength 50
 * - Guidance scale of 6 is prompt strength 0
 *
 * @param scale guidance scale
 *
 * @returns prompt strength, between 0 and 100
 */
export function guidanceScaleToPromptStrength(scale: number) {
  return Math.max(Math.min(roundTo(100 - (scale - 2) * 25, 1), 100), 0);
}

/**
 * Convert prompt strength to a guidance scale value between 2 and 6.
 *
 * @param strength
 * @returns guidance scale, between 2 and 6
 */
export function guidanceScaleFromPromptStrength(strength: number) {
  return Math.max(Math.min(roundTo((100 - strength) / 25 + 2, 0.05), 6), 2);
}

export function getForgeSessionUrl({
  workspaceName,
  sessionId,
  assetId,
}: {
  workspaceName: string;
  sessionId: string;
  assetId?: string;
}) {
  let urlPath = `/${workspaceName}/session/${sessionId}`;

  if (assetId) {
    urlPath += `/asset/${assetId}`;
  }

  return urlPath;
}
